namespace AgerLMS.LMS {
    export interface VideoFileRow {
        Id?: number;
        OriginalFileUploadUrl?: string;
        VideoResolution?: VideoResolutions;
        LessonId?: number;
        ServerVideoFile?: string;
        DeleteServerVideoFile?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace VideoFileRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OriginalFileUploadUrl';
        export const localTextPrefix = 'LMS.VideoFile';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            OriginalFileUploadUrl = "OriginalFileUploadUrl",
            VideoResolution = "VideoResolution",
            LessonId = "LessonId",
            ServerVideoFile = "ServerVideoFile",
            DeleteServerVideoFile = "DeleteServerVideoFile",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
